module.exports = {
  "CS_FE_Select_Product_VbhT": "اختر «دور PM وDEV»",
  "CS_status_Dibi_hJVY": "متابعة ({{time_second}})",
  "CS_1_WiFi_pyYD": "واي فاي",
  "CS_FE_You_can_yIrn": "اختر نوع الإذن الذي تحتاج إليه أدناه، ثم اضغط على «تطبيق».",
  "CS_status_SYOk_iYUs": "معاملات الشركات",
  "CS_status_ZoGi_sjyC": "مركز الكباتن",
  "CS_1_Environment_Bitb": "البيئة",
  "CS_1_View_Current_IOCz": "عرض الأذونات الحالية",
  "CS_optimazation__CALn": "تم تغيير حالتك تلقائيًا إلى وضع عدم الاتصال نظرًا لعدم النشاط. يُرجى تحديث الصفحة.",
  "CS_1_Upgrade_current_dlbi": "ترقية الأذونات الحالية",
  "CS_optimazation_You_have_PlRk": "استمرت حالة الخمول في {{workbench_name}} لمدة {{time_duration}} من الدقائق. هل تريد متابعة العمل في {{workbench_name}}؟",
  "CS_optimazation__akmu": "غير متصل",
  "CS_status_ixVR_bjQc": "المبيعات",
  "CS_feedback_Feedback_bGXI": "التعليقات",
  "CS_optimazation__ZkZb": "البقاء {{work_status}}",
  "CS_System_ZQjn_eCbz": "نوع المهارة التي تم التدرّب عليها سابقًا",
  "CS_status_CjDQ_uaVo": "مكافحة الاحتيال",
  "CS_Status_In_the_PrHj": "يتم أخذ استراحة لدخول دورة المياه...",
  "CS_1_Thank_you_WUlL": "شكرًا على تعليقك!",
  "CS_status_ErSl_RYFT": "اتصال",
  "CS_1_Log_in_sMmF": "تسجيل الخروج",
  "CS_status_HxNd_EpND": "كاميرا السيارة",
  "CS_status_HMDn_eBqC": "التفاعل",
  "CS_status_zoxI_Nral": "نوع الخدمة الحالي هو {{service_type}}",
  "CS_feedback_1_Please_IBbL": "1. يُرجى وصف الميزة التي تواجه فيها مشكلة وذكر ما حدث",
  "CS_1_Closing_Online_tykf": "تعطيل الدردشة المباشرة",
  "CS_1_Open_automatic_PZyZ": "تشغيل تعيين تذكرة الدعم الآلي",
  "CS_FE_Ark_Visitor_pMCT": "أذونات عرض CRM",
  "CS_1_Enter_text_NYGo": "أدخِل النص...",
  "CS_status_WEAx_MWhv": "السلامة",
  "CS_System_lIGK_Ukwr": "نوع المهارة الحالي",
  "CS_optimazation_Telephone_workstations_TBZP": "منصة العمل الخاصة بالاتصال",
  "CS_system_Name_of_QEFT": "المسمى الوظيفي",
  "CS_status_dweh_wRWT": "مراجعة عملية التسجيل",
  "CS_optimazation__work_JhhB": "استمرت حالة {{work_status}} لمدة تزيد عن {{time_duration}} من الدقائق. هل تريد أن تظل في حالة {{work_status}}؟",
  "CS_Workbench_Online_Customer_yXxN": "منصة محادثة مباشرة",
  "CS_status_wfIq_oGhU": "وسائل التواصل الاجتماعي",
  "CS_optimazation_Time_out_sqTe": "تذكير بانتهاء المدة",
  "CS_1_Country_ilYw": "الدولة",
  "CS_1_Closed_automatic_jUvk": "إيقاف تعيين تذكرة الدعم الآلي",
  "CS_1_System_Category_rAJC": "فئة الأعمال",
  "CS_status_aobY_gRor": "استمرت حالة {{status_name}} لمدة تزيد عن {{hour_time}} من الساعات. هل تريد أن تظل في حالة {{status_name}}؟",
  "CS_FE_If_you_lCHy": "في حال كنت عضوًا في فريق منتج خدمة العملاء وتطويره:",
  "CS_status_qORz_iUKj": "عمليات التحصيل",
  "CS_optimazation_The_status_hqOj": "يتعذر تبديل الحالة. يُرجى تسجيل الدخول إلى Genesys.",
  "CS_optimazation_After_the_dZsk": "المعالجة بعد الاتصال",
  "CS_feedback_Please_upload_zHqW": "2. يُرجى تحميل صورة كاملة لمساعدتنا في معرفة تفاصيل المشكلة",
  "CS_system_Sectoral_information_JizK": "معلومات القسم",
  "CS_optimazation__zXnN": "انتهت مهلة {{work_status}}",
  "CS_status_eJtD_Xawt": "الدعم الفني",
  "CS_1_Personal_settings_eXQD": "الإعدادات الشخصية",
  "CS_optimazation_Asynchronous_workstations_JwBF": "منصة العمل التحريرية",
  "CS_status_YyJG_Khkr": "خدمة العملاء",
  "CS_FE_Product_R_RxVt": "دور PM وDEV",
  "CS_1_Online_Customer_SvgB": "تم تمكين الدردشة المباشرة",
  "CS_status_pySZ_YnQN": "مراجعة المحتوى",
  "CS_1_Open_Online_umkV": "تمكين الدردشة المباشرة",
  "CS_1_Languages_hMbf": "اللغة",
  "CS_system_Immediate_superior_VDep": "المشرف",
  "CS_1_Personal_settings_uOXW": "الإعدادات الشخصية",
  "CS_FE_Choose_Ark_VJpl": "اختر «أذونات عرض CRM (رقم تعريف الدور: 14211591)»",
  "CS_1_Permissions_MuvF": "الأذونات",
  "CS_FE_If_you_WAuP": "إذا كان لديك دور مختلف (على سبيل المثال، في الإنتاج والتطوير لتكنولوجيا الأعمال العالمية، أو العمليات، أو زميل في مقر الصين):",
  "CS_status_ocdu_QQQW": "مكالمة فيديو",
  "CS_1_Automatic_Order_Mnnv": "تعيين تذكرة الدعم الآلي يعمل",
  "CS_optimazation_Make_sure_FVAQ": "هل أنت متأكد أنك تريد تبديل حالة {{workbench_name}} من {{status_one}} إلى {{status_two}}؟ بعد التبديل، سيتم تعيين حالة منصات العمل الأخرى إلى {{status_three}}.",
  "CS_1_Comments_RcMN": "إرسال",
  "CS_1_Notification_uJTM": "الإشعارات",
  "status_400": "يتم تناول وجبة...",
  "refreshPage": "تحديث الصفحة",
  "countDownBegin": "التشغيل بعد ",
  "infoChange": "تم تحويل فئة النظام إلى صفحة أخرى. لن يتمكن النظام من حفظ التغييرات التي أجريتها. يُرجى تحديث الصفحة.",
  "view": "عرض",
  "online": "بيئة على الإنترنت",
  "message": "الرسائل",
  "changeStatusV1": "هل أنت متأكد من أنك تريد تغيير حالة العمل من ",
  "changeStatusV2": " إلى ",
  "changeStatusV3": "؟",
  "time": "التاريخ",
  "continue": "المتابعة",
  "knowledge": "قاعدة بيانات",
  "status_500": "يتم أخذ قسط من الراحة...",
  "artificial": "رسالة مباشرة",
  "countDownEnd": "S",
  "clickStartWorking": "لضمان دقة البيانات، يُرجى الضغط على «بدء العمل» قبل استخدام النظام",
  "statusChange": "لقبول تذاكر الدعم تلقائيًا، يُرجى ضبط حالة العمل على «متاح».",
  "CS_Workbench_There_are_wmir": "يتعذّر تغيير حالة العمل. يُرجى إكمال جميع الدردشات المباشرة قيد التقدم أولاً.",
  "type": "نوع الرسالة",
  "status_200": "التدريب قيد التقدم...",
  "cancel": "إلغاء",
  "logout": "تسجيل الخروج",
  "sendTo": "إلى",
  "satisfaction_content": "لديك استطلاع رأي سيستغرق منك إكماله حوالي 5 دقائق. إذا كنت تريد إكماله الآن، يمكنك الضغط على الرابط أدناه أو الزر «متابعة» للانتقال إلى صفحة الاستطلاع.",
  "CS_Workbench_Open_the_lnHa": "عند استخدام منصة العمل الخاصة بالدردشة المباشرة، يُرجى التأكد من أنه تم ضبط حالة العمل على «متاح».",
  "ticketNumber": " من تذاكر الدعم المعلقة",
  "more": "المزيد",
  "satisfaction_title": "استطلاع من أجلك",
  "pre": "بيئة ما قبل الحدث",
  "customerService": "مَركز اتصال",
  "status_300": "الاجتماع قيد التقدم...",
  "sendFrom": "مِن",
  "youhave": "لديك ",
  "startWorking": "بدء العمل",
  "small": "بيئة قبول",
  "offWorkV": "هل أنت متأكد من أنك تريد الانتقال إلى وضع عدم الاتصال؟ سيسجل هذا موعد انتهاء عملك لليوم.",
  "read": "تمت القراءة",
  "Settings": "الإعدادات",
  "welcomeCS": "مرحبًا بك في نظام دي دي العالمي لخدمة العملاء.",
  "cs-micro-front-end---more": "",
  "cs-micro-front-end---welcomeCS": "",
  "cs-micro-front-end---clickStartWorking": "",
  "cs-micro-front-end---startWorking": "",
  "cs-micro-front-end---status_200": "",
  "cs-micro-front-end---status_300": "",
  "cs-micro-front-end---status_400": "",
  "cs-micro-front-end---status_500": "",
  "cs-micro-front-end---offWorkV": "",
  "cs-micro-front-end---changeStatusV1": "",
  "cs-micro-front-end---changeStatusV2": "",
  "cs-micro-front-end---changeStatusV3": "",
  "cs-micro-front-end---cancel": "",
  "cs-micro-front-end---continue": "",
  "cs-micro-front-end---logout": "",
  "cs-micro-front-end---online": "",
  "cs-micro-front-end---pre": "",
  "cs-micro-front-end---small": "",
  "cs-micro-front-end---statusChange": "",
  "cs-micro-front-end---youhave": "",
  "cs-micro-front-end---ticketNumber": "",
  "cs-micro-front-end---view": "",
  "cs-micro-front-end---Settings": "",
  "cs-micro-front-end---infoChange": "",
  "cs-micro-front-end---refreshPage": "",
  "cs-micro-front-end---satisfaction_title": "",
  "cs-micro-front-end---satisfaction_content": "",
  "cs-micro-front-end---knowledge": "",
  "cs-micro-front-end---customerService": "",
  "cs-micro-front-end---artificial": "",
  "cs-micro-front-end---sendFrom": "",
  "cs-micro-front-end---sendTo": "",
  "cs-micro-front-end---type": "",
  "cs-micro-front-end---time": "",
  "cs-micro-front-end---read": "",
  "cs-micro-front-end---countDownBegin": "",
  "cs-micro-front-end---countDownEnd": "",
  "cs-micro-front-end---CS_Workbench_There_are_wmir": "",
  "cs-micro-front-end---CS_Workbench_Open_the_lnHa": "",
  "cs-micro-front-end---message": "",
  "CS_Tools_Ark_System_Quick_Access_for_Permission_Application_Sorry_permissions_nBRG": "Sorry, you don’t have permission to access the system. To request permission, please follow the instructions below.",
  "CS_Tools_Ark_System_Quick_Access_for_Permission_Application_Customer_service_oPui": "If you’re not a Customer Service Representative:",
  "CS_Tools_Ark_System_Quick_Access_for_Permission_Application_Production_and_mGLI": "Select the permission type you need below, then click Apply.\n\nIf you’re on the customer service product and development team: Select the ‘PM and DEV Role‘\n\nFor other roles (IBT product and development, operations, or domestic staff): Select the ‘CRM View Permission (Role ID: 14211591)’",
  "CS_Tools_Ark_System_Quick_Access_for_Permission_Application_See_permissions_OzjQ": "For more information, please refer to the Customer Service System Access Guidelines",
  "CS_Tools_Ark_System_Quick_Access_for_Permission_Application_Permission_Kapv": "Select your access permission",
  "CS_Tools_Ark_System_Quick_Access_for_Permission_Application_Customer_service_vLUC": "If you’re a Customer Service Representative:",
  "CS_Tools_Ark_System_Quick_Access_for_Permission_Application_Hello_permissions_SDxI": "Please contact your supervisor or local admin responsible for customer service permissions for assistance.",
  "CS_system_Submission_cEep": "Submit"
}